import axios from 'axios';

const httpClient = axios.create({
  xsrfCookieName: false,
  xsrfHeaderName: false,
  withCredentials: false,
});

export default httpClient;
